import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCurrentPage = create<{
  currentPage: string;
  setCurrentPage: (v: string) => void;
  turnToPage: (navigate: (path: string) => void) => void;
}>()(
  persist(
    (set, get) => ({
      currentPage: '',
      setCurrentPage: (v: string) => {
        set((state) => ({ ...state, currentPage: v }));
      },
      turnToPage: (navigate: (path: string) => void) => {
        const businessOrigin = process.env.BUSINESS_ORIGIN;
        const supplierOrigin = process.env.SUPPLIER_ORIGIN;
        const currentOrigin = window.location.origin;
        if(currentOrigin === businessOrigin){
          window.location.href = `${businessOrigin}/go`;
        } else if(currentOrigin === supplierOrigin){
          window.location.href = `${supplierOrigin}/s`;
        }
      },
    }),
    {
      name: 'current-page-storage',
      partialize: (state) => ({ currentPage: state.currentPage }), 
    }
  )
);
